var model = BD.Model.extend({
    name: BD.attr('string'),
    icon: BD.attr('string'),
    memberCountryIds: BD.attr('object')
})

model.reopenClass({
    qProperties: ['id', 'name']
})

module.exports = model
